export default __webpack_public_path__ + "static/media/likes_main_gold.bfe28123.png";